// Si hace rato que no se genera en Redes, la sesión abre en el estado inicial —
// ADR-2026-10-08-redes-abre-colapsado-tras-un-rato.
//
// Una sesión existente abría siempre en sus creaciones (el lienzo o la cuadrícula). Después
// de un rato sin generar, lo que el usuario viene a hacer es generar otra cosa, no mirar lo
// de antes: abre en la portada (la caja al centro) con las creaciones colapsadas detrás de
// "Ver creaciones". Se recuerda en `localStorage` cuándo fue la última generación en Redes
// (en cualquier sesión): es una comodidad de este navegador, no un dato que deba viajar.

const CLAVE = 'atlas:redes:ultima-generacion';

/** Cuánto es "un rato" sin generar. */
export const RATO_SIN_GENERAR_MS = 60 * 60 * 1000;

/** ¿Pasó un rato desde la última generación? Sin registro, sí. Pura (el reloj por parámetro). */
export function pasoUnRato(ultima: number | null, ahora: number, rato: number = RATO_SIN_GENERAR_MS): boolean {
  if (ultima === null || !Number.isFinite(ultima)) return true;
  // Un registro en el futuro (reloj corrido) no deja la portada muda para siempre.
  if (ultima > ahora) return false;
  return ahora - ultima >= rato;
}

export function leerUltimaGeneracion(): number | null {
  try {
    const v = localStorage.getItem(CLAVE);
    const n = v ? Number(v) : NaN;
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

/** Se generó algo en Redes ahora. */
export function recordarGeneracionEnRedes(ahora: number = Date.now()): void {
  try {
    localStorage.setItem(CLAVE, String(ahora));
  } catch {
    /* sin storage: la sesión vuelve a abrir en sus creaciones, como antes */
  }
}

/** Con qué vista abre una sesión EXISTENTE de Redes, según la última generación. */
export const vistaAlEntrar = (ahora: number = Date.now()): 'plantillas' | 'lienzo' =>
  pasoUnRato(leerUltimaGeneracion(), ahora) ? 'plantillas' : 'lienzo';
